import { useState } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';

import { createContactTW } from 'flow/actions/contact-actions';
import CreateContact from 'flow/components/contact-components/CreateContact';
import BaseModal from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';
import { Map } from 'immutable';
import { isThirdPartyContactKey } from 'flow/utils';
import { getContactMapFromThirdPartyContact } from 'flow/utils/extension-utils';
import { TypedMap } from 'flow/types/TypedMap';
import { Contact } from 'flow/types/Contact';
import { convertNumberToE164 } from 'flow/utils/call-utils';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

const initializeContact = (contact: TypedMap<any>, initialNumber: any) => {
    let initialContact = contact || Map();

    if (initialNumber) {
        const convertedNumber = convertNumberToE164(initialNumber);
        const phoneNumber = parsePhoneNumberFromString(convertedNumber);
        const numberType = phoneNumber?.getType();

        const setInArr =
            numberType === 'MOBILE'
                ? ['mobile', 'number']
                : ['fixed', 'number'];
        initialContact = initialContact.setIn(setInArr, convertedNumber);
    }

    return initialContact;
};

interface Props {
    contact?: TypedMap<any>;
    countryCode?: string;
    initialNumber?: any;
}

const CreateContactModal = ({ contact, countryCode, initialNumber }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const [interimContactDTO, setInterimContactDTO] = useState(() =>
        initializeContact(contact, initialNumber),
    );

    const createNewContact = () => {
        const contactWithType = interimContactDTO.set('type', 'personal');
        dispatch(createContactTW(contactWithType, true));
    };

    const getContactMap = (contact: TypedMap<Contact>) => {
        if (!contact) {
            return Map();
        }

        if (isThirdPartyContactKey(contact.get('key'))) {
            return getContactMapFromThirdPartyContact(contact);
        }
        return contact;
    };

    return (
        <BaseModal
            open={true}
            header={i18next.t('Colleagues.Create.External.Title')}
            onSubmit={createNewContact}
            disableSubmit={
                interimContactDTO?.isEmpty() ||
                interimContactDTO.equals(contact)
            }
            disablePadding={true}
        >
            <CreateContact
                userCountryCode={countryCode}
                updateContact={setInterimContactDTO}
                updatedContact={
                    getContactMap(interimContactDTO) as TypedMap<Contact>
                }
            />
        </BaseModal>
    );
};

export default CreateContactModal;
